// export enum PaymentType {
// 	Visa = 1,
// 	MasterCard = 2,
// 	AmericanExpress = 3,
// 	Invoice = 4,
// 	ACH = 5,
// 	CreditCard = 6,
// 	PayrollDeduct = 7,
// 	PayPal = 8,
// }
export enum PaymentType {
	ACH = 'ACH',
	CreditCard = 'Credit Card',
}
